import { useIonViewDidLeave } from "@ionic/react";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import useState from "react-usestateref";
import { Circle, FRAME_MIN_TIME } from "../../lib/audioVisualizer";

interface ComponentProps {
  sensitivity;
  isRunning;
  width;
  height;
}

const AVComponent: React.FC<ComponentProps> = ({
  sensitivity,
  isRunning,
  width,
  height,
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [stream, setStream] = useState<MediaStream | null>(null);
  const circlesArray: Circle[] = [];
  let lastFrameTime = 0; // the last frame time
  let frameCount = 0;
  let animationFrameId = 0;

  const audioTest = async (
    context: CanvasRenderingContext2D | null,
    centerX: number,
    centerY: number
  ) => {
    if (navigator.mediaDevices.getUserMedia !== null) {
      const options = {
        video: false,
        audio: true,
      };
      try {
        const result = await navigator.mediaDevices.getUserMedia(options);
        const audioCtx = new AudioContext();
        const analyser = audioCtx.createAnalyser();
        analyser.fftSize = 128;
        const audioSrc = audioCtx.createMediaStreamSource(result);
        audioSrc.connect(analyser);
        const data = new Uint8Array(analyser.frequencyBinCount);
        context!.lineCap = "round";
        setStream(result);

        const init = () => {
          // draw(context, centerX, centerY, frameCount, data);
          circlesArray.push(
            new Circle(
              context!,
              centerX,
              centerY,
              frameCount,
              data,
              sensitivity
            )
          );
        };
        init();
        //Our draw came here
        const handleCircles = () => {
          for (let i = 0; i < circlesArray.length; i++) {
            circlesArray[i].update();
            circlesArray[i].draw();
            if (circlesArray[i].size <= 0.2) {
              circlesArray.splice(i, 1);
              i--;
            }
          }
        };
        const animate = (time: number) => {
          // console.log("animating...");
          if (time - lastFrameTime < FRAME_MIN_TIME) {
            //skip the frame if the call is too early
            animationFrameId = requestAnimationFrame(animate);
            return; // return as there is nothing to do
          }
          lastFrameTime = time;
          //skip the frame if the call is too early
          frameCount++;
          context!.clearRect(
            0,
            0,
            canvasRef.current?.width || 0,
            canvasRef.current?.height || 0
          );
          analyser.getByteFrequencyData(data);
          handleCircles();
          // draw(context, centerX, centerY, frameCount, data);
          circlesArray.push(
            new Circle(
              context!,
              centerX,
              centerY,
              frameCount,
              data,
              sensitivity
            )
          );

          animationFrameId = window.requestAnimationFrame(animate);
        };
        animationFrameId = window.requestAnimationFrame(animate);
      } catch (err) {
        console.log(err);
        alert(err);
      }
    }
  };
  useEffect(() => {
    if (canvasRef.current && isRunning) {
      // console.log("used effect");
      window.cancelAnimationFrame(animationFrameId);
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");
      const { width, height } = canvas.getBoundingClientRect();
      const { devicePixelRatio: dpr = 1 } = window;
      canvas.width = width * dpr;
      canvas.height = height * dpr;
      context!.scale(dpr, dpr);
      audioTest(context, canvas.width / 2 / dpr, canvas.height / 2 / dpr);
    } else if (canvasRef.current) {
      // animationFrameId = requestAnimationFrame(audioTest.bind(this));
      // console.log(animationFrameId, "canceled");
      window.cancelAnimationFrame(animationFrameId);
    }
    // console.log("used effect");
    return () => {
      window.cancelAnimationFrame(animationFrameId);
    };
  }, [canvasRef.current, isRunning]);
  useIonViewDidLeave(() => {
    stream && stream.getTracks().forEach((track) => track.stop());
  });
  useEffect(() => {
    return () => {
      stream && stream.getTracks().forEach((track) => track.stop());
    };
  }, [stream]);
  return (
    <canvas
      className="mx-auto h-[calc(100vh-var(--ion-safe-area-top)-var(--ion-safe-area-bottom)-3rem)] max-h-[1000px] w-screen max-w-[1000px] bg-transparent"
      ref={canvasRef}
      tabIndex={0}
    />
  );
};

export default AVComponent;
